window.S8Analytics = window.S8Analytics || {
  pushDataLayerEvent(eventName, params = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...params });
  },

  trackUpsellAddToCart({ context, listId, listName, items }) {
    if (!context || !items?.length) return;

    const currency = window.Shopify?.currency?.active || 'GBP';
    const value = items.reduce((sum, item) => sum + (Number(item.price) || 0) * (Number(item.quantity) || 1), 0) / 100;

    this.pushDataLayerEvent('add_to_cart', {
      upsell_context: context,
      currency,
      value,
      ecommerce: {
        currency,
        value,
        item_list_id: listId,
        item_list_name: listName,
        items: items.map((item) => ({
          ...item,
          price: (Number(item.price) || 0) / 100,
          item_list_id: listId,
          item_list_name: listName,
          upsell_context: context,
        })),
      },
    });

    this.pushDataLayerEvent('upsell_interaction', {
      upsell_context: context,
      upsell_action: 'add_to_cart',
    });
  },

  trackUpsellInteraction({ context, action }) {
    if (!context || !action) return;

    this.pushDataLayerEvent('upsell_interaction', {
      upsell_context: context,
      upsell_action: action,
    });
  },

  trackUpsellSelectItem({ context, listId, listName, item }) {
    if (!context || !item) return;

    this.pushDataLayerEvent('select_item', {
      upsell_context: context,
      ecommerce: {
        item_list_id: listId,
        item_list_name: listName,
        items: [
          {
            ...item,
            price: (Number(item.price) || 0) / 100,
            item_list_id: listId,
            item_list_name: listName,
            upsell_context: context,
          },
        ],
      },
    });

    if (context === 'set_upsell') {
      this.pushDataLayerEvent('upsell_interaction', {
        upsell_context: context,
        upsell_action: 'select_item',
      });
    }
  },

  trackVideoMilestone({ contentType, videoId, milestone }) {
    if (!contentType || !videoId || milestone === undefined) return;

    this.pushDataLayerEvent('video_progress', {
      content_type: contentType,
      video_id: videoId,
      milestone: String(milestone),
    });
  },
};

document.addEventListener('click', (evt) => {
  const link = evt.target.closest('a[data-product-card-link]');
  if (!link) return;

  const contextEl = link.closest('[data-upsell-context]');
  if (!contextEl) return;

  window.S8Analytics.trackUpsellSelectItem({
    context: contextEl.dataset.upsellContext,
    listId: contextEl.dataset.upsellListId,
    listName: contextEl.dataset.upsellListName,
    item: {
      item_id: contextEl.dataset.upsellVariantId,
      item_name: contextEl.dataset.upsellProductTitle,
      price: contextEl.dataset.upsellPrice,
    },
  });
  // No preventDefault/stopPropagation: dataLayer.push is synchronous and
  // does not block or delay the browser's normal navigation to href.
});
